import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {AccountModel} from "../../account/angular/models/account.model";

require('./../views/dialogs/scan-packages-dialog.scss');

export class SelfPickupsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private moment, private $log) {
  }

  // ******************************
  // External methods
  // ******************************

  createOne(depot, event) {
    const outer = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/self-pickup-create-dialog.html').default,
      controller: function ($scope, $log, VehiclesConstants) {

        $scope.vehiclePricingTypes = VehiclesConstants.vehiclePricingTypes;
        $scope.vehicleMakes = VehiclesConstants.makes;
        $scope.vehicleColors = VehiclesConstants.colors;

        $scope.header = 'Create Self Pickup';
        $scope.submit = 'Create';
        $scope.depotIds = [depot.id];

        $scope.selfPickup = {
          accountId: undefined,
          depotId: depot.id,
          status: undefined,
          type: 'InStore', // InStore | Curbside
          notBefore: moment().minute(0).seconds(0).millisecond(0).valueOf(),
          notAfter: moment().add(2, 'hour').minute(0).seconds(0).millisecond(0).valueOf(),
          comments: undefined,
          contact: {
            name: undefined,
            phoneNo: undefined
          },
          packages: [{items: []}]
          // vehicleInfo: {
          //     make: undefined,
          //     models: undefined,
          //     color: undefined,
          //     plateNumber: undefined
          // }
        };
        $scope.selectedDepot = angular.copy(depot);

        $scope.cancel = outer.$mdDialog.cancel;

        $scope.onAccountSelect = onAccountSelect;
        $scope.onDepotSelect = onDepotSelect;
        $scope.onPhoneChange = onPhoneChange;
        $scope.onTimeAndDateChange = onTimeAndDateChange;
        $scope.onTypeChange = onTypeChange;
        $scope.onAddPackageItem = onAddPackageItem;
        $scope.onRemovePackageItem = onRemovePackageItem;

        // ******************************
        // External methods
        // ******************************

        function onAccountSelect(account: AccountModel) {
          $scope.selfPickup.accountId = _.get(account, 'id');
        }

        function onDepotSelect(depot) {
          $scope.selfPickup.depot = _.get(depot, 'id');
        }

        function onPhoneChange(phone) {
          $scope.selfPickup.contact.phoneNo = phone;
        }

        function onTimeAndDateChange(from, to) {
          $scope.selfPickup.notBefore = from;
          $scope.selfPickup.notAfter = to;
        }

        function onTypeChange(type) {
          if (type === 'Curbside') {
            $scope.selfPickup.vehicleInfo = {
              make: undefined,
              model: undefined,
              color: undefined,
              plateNumber: undefined
            };
          } else {
            _.unset($scope.selfPickup, 'vehicleInfo')
          }
        }

        function onAddPackageItem(item) {
          $scope.selfPickup.packages[0].items.push(item);
        }

        function onRemovePackageItem(index) {
          $scope.selfPickup.packages[0].items.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              outer.$mdDialog.hide($scope.selfPickup)

            }
          } else {
            $log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editOne(selfPickup, depot?, event?) {
    const outer = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/self-pickup-create-dialog.html').default,
      controller: function ($scope, VehiclesConstants) {

        $scope.vehiclePricingTypes = VehiclesConstants.vehiclePricingTypes;
        $scope.vehicleMakes = VehiclesConstants.makes;
        $scope.vehicleColors = VehiclesConstants.colors;

        $scope.header = 'Edit Self Pickup';
        $scope.submit = 'Update';
        $scope.depotIds = [selfPickup.depotId];

        $scope.selfPickup = angular.copy(selfPickup);
        $scope.selectedDepot = angular.copy(depot);

        $scope.cancel = outer.$mdDialog.cancel;

        $scope.onAccountSelect = onAccountSelect;
        $scope.onDepotSelect = onDepotSelect;
        $scope.onPhoneChange = onPhoneChange;
        $scope.onTimeAndDateChange = onTimeAndDateChange;
        $scope.onTypeChange = onTypeChange;

        $scope.onAddPackageItem = onAddPackageItem;
        $scope.onRemovePackageItem = onRemovePackageItem;

        // ******************************
        // External methods
        // ******************************

        function onAccountSelect(account :AccountModel) {
          $scope.selfPickup.accountId = _.get(account, 'id');
        }

        function onDepotSelect(depot) {
          $scope.selfPickup.depot = _.get(depot, 'id');
        }

        function onPhoneChange(phone) {
          $scope.selfPickup.contact.phoneNo = phone;
        }


        function onTimeAndDateChange(from, to) {
          $scope.selfPickup.notBefore = from;
          $scope.selfPickup.notAfter = to;
        }

        function onTypeChange(type) {
          if (type === 'Curbside') {
            $scope.selfPickup.vehicleInfo = {
              make: undefined,
              model: undefined,
              color: undefined,
              plateNumber: undefined
            };
          } else {
            _.unset($scope.selfPickup, 'vehicleInfo')
          }
        }

        function onAddPackageItem(item) {
          $scope.selfPickup.packages[0].items.push(item);
        }

        function onRemovePackageItem(index) {
          $scope.selfPickup.packages[0].items.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              outer.$mdDialog.hide($scope.selfPickup)
            }
          } else {
            outer.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  moveToReady(packages, contact, selfPickupId, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/move-to-ready-dialog.html').default,
      controller: function ($scope) {

        $scope.packages = packages ? angular.copy(packages) : [{items: []}];
        $scope.contactName = _.get(contact, 'name');
        $scope.selfPickupId = selfPickupId;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddPackageItem = onAddPackageItem;
        $scope.onRemovePackageItem = onRemovePackageItem;

        // ******************************
        // External methods
        // ******************************

        function onAddPackageItem(item) {
          $scope.packages[0].items.push(item);
        }

        function onRemovePackageItem(index) {
          $scope.packages[0].items.splice(index, 1);
        }

        $scope.onSubmit = (form, status) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload = {
                packages: $scope.packages,
                status: status
              };
              self.$mdDialog.hide(payload)

            }
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  signature(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/signature-dialog.html').default,
      controller: function ($scope, uploadFile) {

        $scope.loading = false;

        $scope.name = undefined;
        $scope.signature = {
          data: undefined
        };

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onSubmit = () => {
          if ($scope.signature.data) {
            $scope.urlToFile($scope.signature.data, 'signature.png')
              .then((signatureImage) => {
                $scope._uploadSignature(signatureImage)
              });
          } else {
            self.$mdDialog.hide()
          }

        }

        $scope.urlToFile = (url, filename, mimeType?) => {
          mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
          return (fetch(url)
              .then((res) => {
                return res.arrayBuffer();
              })
              .then((buf) => {
                return new File([buf], filename, {type: mimeType});
              })
          );
        }

        $scope._uploadSignature = (signatureImage) => {
          $scope.loading = true;
          uploadFile(signatureImage)
            .then((response) => {
              const payload = {
                signerName: $scope.name,
                signatureUrl: _.get(response, 'data.url')
              };
              self.$mdDialog.hide(payload)
            })
            .catch((error) => {
              if (error) {
                self.$log.error('Failed to upload signature', error);
              }
            })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  scanPackages(packageList, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/scan-packages-dialog.html').default,
      controller: function ($scope) {

        $scope.package = packageList ? angular.copy(packageList) : {count: 0};
        $scope.maxCount = $scope.package.count || 0;
        $scope.scannedItems = [];
        $scope.manualBarcode = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddBarcode = onAddBarcode;
        $scope.onManualSubmit = onManualSubmit;
        $scope.onRemoveScannedItem = onRemoveScannedItem;

        // Listen for scans coming from the USB barcode reader (see barcode-scanner-service.service.ts)
        $scope.$on('barcode-scanned', (_event, barcode) => {
          onAddBarcode(barcode);
        });

        // ******************************
        // External methods
        // ******************************

        function onAddBarcode(barcode) {
          if (barcode && $scope.scannedItems.length < $scope.maxCount) {
            $scope.scannedItems.push(barcode);
          }
        }

        function onManualSubmit() {
          if ($scope.manualBarcode) {
            onAddBarcode($scope.manualBarcode);
            $scope.manualBarcode = undefined;
          }
        }

        function onRemoveScannedItem(index) {
          $scope.scannedItems.splice(index, 1);
        }

        $scope.onSubmit = () => {
          if ($scope.scannedItems.length >= $scope.maxCount) {
            self.$mdDialog.hide($scope.scannedItems);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .service('selfPickupsDialogService', SelfPickupsDialogService);
